function UserTwoFASecret() {
    this.__type = 'UserTwoFASecret:www.veritracks.com';
    this.Id = -1;
    this.UserSecretKey = '';
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = UserTwoFASecret;
}